<template>
  <div class="partner-select">
    <SACSearch
      :search="search"
      :height="40"
      @input="(value) => changeSearch(value)"
    />
    <div class="partner-options">
      <div
        v-for="(option, idx) in options"
        :key="idx"
      >
        <button
          type="button"
          :class="[
            'op-button',
            item.activeOption.value === option.value ? 'active' : '',
          ]"
          @click="select(option, item.key)"
        >
          <span>{{ option.label }}</span>
          <img
            v-if="item.activeOption.value === option.value"
            src="@shared/assets/img/general/check-white.png"
            class="img-size_12"
            alt="Selected"
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SACSearch from '../../sac/SACSearch.vue';

export default {
  name: 'SearchOption',
  components: {
    SACSearch,
  },
  props: {
    item: Object,
    select: Function,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    options() {
      const {
        options,
      } = this.item;
      const {
        search,
      } = this;
      const newOptions = options.slice();
      if (search) {
        return newOptions.filter((option) => {
          const text = search.toLowerCase();
          const {
            label,
          } = option;
          return !!label.toLowerCase().match(text);
        });
      }
      return newOptions;
    },
  },
  methods: {
    changeSearch(search) {
      this.search = search;
    },
  },
};
</script>

<style lang="scss">
.partner-select {
  display: grid;
  gap: 23px;
  width: 100%;
  .partner-options {
    display: grid;
    gap: 8px;
    max-height: 400px;
    @media (max-width: 1600px) {
      max-height: 300px;
    }
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 20px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #d6dee1;
      border-radius: 20px;
      border: 6px solid transparent;
      background-clip: content-box;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #a8bbbf;
    }
    .op-button {
      height: 40px;
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
      background-color: $N5;
      width: 100%;
      font-size: 0.875rem;
      color: $NAVY100;
      border-radius: 8px;
      padding: 0 17px;
      &.active {
        background-color: $NBLUE110;
        color: $WHITE;
      }
      .img-size_12 {
        height: 12px;
        width: auto;
      }
    }
  }
}

</style>
